<div class="kiene-content-page">
    <div class="one-row">
        <button style="margin-bottom: 1.25em" (click)="goBack()" mat-icon-button matTooltip="zurück">
            <mat-icon color="primary">arrow_back</mat-icon>
        </button>
        <h1>Antibiogramm {{ antibiogramm?.tagebuch_nr }}</h1>
        <span class="spacer"></span>
        <div *kienePermission="[1819]">
            <button
                *ngIf="antibiogramm?.status === 1"
                (click)="resendAntibiogrammToMCN6()"
                mat-icon-button
                matTooltip="Erneut an MCN6 übertragen"
            >
                <mat-icon color="primary">cached</mat-icon>
            </button>
        </div>
        <div *kienePermission="[1817]">
            <button
                *ngIf="antibiogramm?.status === 3"
                (click)="openPdf(antibiogramm)"
                mat-icon-button
                matTooltip="Download Ergebnis Resistenztest als PDF"
            >
                <mat-icon color="primary">cloud_download</mat-icon>
            </button>
        </div>
    </div>
    <table style="max-width: 600px">
        <tr>
            <td>Kunde (Nr.):</td>
            <td>
                <strong>{{ antibiogramm?.kunde }} ({{ antibiogramm?.kunde_nr_intern }})</strong>
            </td>
        </tr>
        <tr>
            <td>Kunde Zusatz:</td>
            <td>
                <strong>{{ currentGruppe?.zusatz }}</strong>
            </td>
        </tr>
        <tr>
            <td>Gruppe:</td>
            <td>
                <strong>{{ currentGruppe?.bezeichnung }}</strong>
            </td>
        </tr>
    </table>
    <div *ngIf="hasPermission(1313) && antibiogramm.status < 0">
        <div class="kiene-table-header">
            <mat-card style="width: 100%">
                <div class="one-row">
                    <mat-form-field>
                        <mat-label>Probenentnahmedatum</mat-label>
                        <input
                            matInput
                            [matDatepicker]="probenentnahmePicker"
                            placeholder="Probenentnahmedatum"
                            [formControl]="probenentnahmeCtrl"
                            [(ngModel)]="antibiogramm.probenentnahme"
                        />
                        <mat-datepicker-toggle matSuffix [for]="probenentnahmePicker"></mat-datepicker-toggle>
                        <mat-datepicker #probenentnahmePicker></mat-datepicker>
                    </mat-form-field>
                    <span class="spacer"></span>
                    <mat-form-field>
                        <mat-label>Untersuchungsbeginn</mat-label>
                        <input
                            matInput
                            [matDatepicker]="eingangPicker"
                            placeholder="Untersuchungsbeginn"
                            [(ngModel)]="antibiogramm.eingang"
                        />
                        <mat-datepicker-toggle matSuffix [for]="eingangPicker"></mat-datepicker-toggle>
                        <mat-datepicker #eingangPicker></mat-datepicker>
                    </mat-form-field>
                    <span class="spacer"></span>
                </div>

                <h3>Test hinzuf&uuml;gen</h3>
                <div class="one-row">
                    <mat-form-field style="min-width: 200px; width: 30%">
                        <mat-label>Testart</mat-label>
                        <mat-select placeholder="Testart" [(value)]="currentIsolat.testart">
                            <mat-option value="R1">R1</mat-option>
                            <mat-option value="R2">R2</mat-option>
                            <mat-option value="H1">H1</mat-option>
                            <mat-option value="H2">H2</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <span class="spacer"></span>
                    <kiene-autocomplete
                        #verdachtAutocomplete
                        style="min-width: 200px; width: 30%"
                        [apiUrl]="'verdacht/'"
                        [placeholder]="'Verdacht'"
                        [displayFields]="['verdacht', 'kuerzel']"
                        [separator]="' - '"
                        [kieneObject]="currentVerdacht"
                        [focus]="false"
                        (elementSelected)="setCurrentVerdacht($event)"
                    ></kiene-autocomplete>
                    <span class="spacer"></span>
                    <mat-form-field style="min-width: 400px; width: 30%">
                        <mat-label>Tierart</mat-label>
                        <mat-select [formControl]="tierartCtrl" [compareWith]="tierartenComparator">
                            <mat-option *ngFor="let t of tierartenList" [value]="t"
                                >{{ t?.tierart }} - {{ t?.kuerzel }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="one-row">
                    <mat-form-field style="min-width: 300px; width: 30%">
                        <mat-label>Infektionsart</mat-label>
                        <input
                            type="text"
                            matInput
                            placeholder="Infektionsart"
                            [formControl]="infektionCtrl"
                            [matAutocomplete]="infektionAuto"
                        />
                    </mat-form-field>
                    <mat-autocomplete #infektionAuto="matAutocomplete" [displayWith]="displayInfektionsart">
                        <mat-option *ngFor="let i of filteredInfektionsarten | async" [value]="i"
                            >{{ i?.kuerzel }} - {{ i?.bezeichnung }}
                        </mat-option>
                    </mat-autocomplete>
                    <span class="spacer"></span>
                    <mat-form-field style="min-width: 500px; width: 30%">
                        <mat-label>Kommentar</mat-label>
                        <input type="text" matInput placeholder="Kommentar" [(ngModel)]="currentIsolat.kommentar" />
                    </mat-form-field>
                    <span class="spacer"></span>
                    <mat-form-field style="min-width: 300px; width: 30%">
                        <mat-label>Kennzeichnung</mat-label>
                        <input
                            type="text"
                            matInput
                            placeholder="Kennzeichnung"
                            [(ngModel)]="currentIsolat.kennzeichnung"
                        />
                    </mat-form-field>
                </div>
                <div class="one-row">
                    <span class="spacer"></span>
                    <button
                        *kienePermission="[1812]"
                        [disabled]="!currentIsolat?.testart"
                        mat-flat-button
                        color="accent"
                        (click)="saveIsolat()"
                    >
                        <span>Speichern</span>
                    </button>
                    <button *ngIf="currentIsolat.testart" mat-stroked-button color="accent" (click)="resetFelder()">
                        <span>Felder leeren</span>
                    </button>
                </div>
            </mat-card>
        </div>
        <h3 *ngIf="resTestList?.length > 0">Tests</h3>
        <mat-card *ngIf="resTestList?.length > 0 && antibiogramm?.status < 0" style="margin-top: 10px">
            <table cdkDropList (cdkDropListDropped)="drop($event)" style="width: 100%">
                <thead>
                    <tr>
                        <th></th>
                        <th style="text-align: left; font-size: 12px; color: #777"> # </th>
                        <th style="text-align: left; font-size: 12px; color: #777"> Testart </th>
                        <th style="text-align: left; font-size: 12px; color: #777"> Verdacht </th>
                        <th style="text-align: left; font-size: 12px; color: #777"> Tierart </th>
                        <th style="text-align: left; font-size: 12px; color: #777"> Infektionsart </th>
                        <th style="text-align: left; font-size: 12px; color: #777"> Kommentar </th>
                        <th style="text-align: left; font-size: 12px; color: #777"> Kennzeichnung </th>
                        <th style="text-align: left; font-size: 12px; color: #777"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr (click)="editIsolat(t)" *ngFor="let t of resTestList; let i = index" cdkDrag>
                        <td style="color: gray; cursor: grab">
                            <mat-icon>drag_handle</mat-icon>
                        </td>
                        <td style="width: 5%">{{ t?.isolatenNummer }}.</td>
                        <td style="width: 15%">{{ t?.testart }}</td>
                        <td style="width: 15%">{{ t?.verdacht }}</td>
                        <td style="width: 15%">{{ getTierartName(t?.tierart) }}</td>
                        <td style="width: 15%">
                            {{ getInfektionsartName(t?.infektionsart) }}
                        </td>
                        <td style="width: 15%">{{ t?.kommentar }}</td>
                        <td style="width: 15%">{{ t?.kennzeichnung }}</td>
                        <td style="width: 5%">
                            <kiene-delete-button (delete)="deleteIsolate(i)"></kiene-delete-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </mat-card>

        <div *kienePermission="[1812]" class="one-row">
            <span class="spacer"></span>
            <button
                (click)="saveAntibiogrammOrder(0)"
                style="margin-top: 10px"
                *ngIf="resTestList?.length > 0"
                [disabled]="antibiogramm?.tagebuch_nr === null || antibiogramm?.tagebuch_nr === 'neu' || !currentGruppe"
                mat-flat-button
                color="accent"
            >
                Abschlie&szlig;en zum &Uuml;bertragen
            </button>
        </div>
    </div>
    <div>
        <div *ngIf="testResult == null && testDescription != null && antibiogramm?.status >= 0">
            <mat-card style="margin-top: 10px">
                <table style="width: 100%">
                    <thead>
                        <tr>
                            <th style="text-align: left; font-size: 12px; color: #777"> # </th>
                            <th style="text-align: left; font-size: 12px; color: #777"> Testart </th>
                            <th style="text-align: left; font-size: 12px; color: #777"> Verdacht </th>
                            <th style="text-align: left; font-size: 12px; color: #777"> Tierart </th>
                            <th style="text-align: left; font-size: 12px; color: #777"> Infektionsart </th>
                            <th style="text-align: left; font-size: 12px; color: #777"> Kommentar </th>
                            <th style="text-align: left; font-size: 12px; color: #777"> Kennzeichnung </th>
                        </tr>
                    </thead>
                    <tr *ngFor="let t of testDescription?.testOrderResultRecords; let i = index">
                        <td style="width: 10%"> {{ t.testOrderRecord?.isolatenNummer }}. </td>
                        <td style="width: 15%">
                            {{ t.resultRecord?.testart }}
                        </td>
                        <td style="width: 15%">
                            {{ t.resultRecord?.verdacht }}
                        </td>
                        <td style="width: 15%">
                            {{ getTierartName(t.testOrderRecord?.einsenderKuerzel) }}
                        </td>
                        <td style="width: 15%">
                            {{ getInfektionsartName(t.testOrderRecord?.materialartenKuerzel) }}
                        </td>
                        <td style="width: 15%">
                            {{ t.testOrderRecord?.isoKommentar }}
                        </td>
                        <td style="width: 15%">
                            {{ t.testOrderRecord?.kennzeichnung }}
                        </td>
                    </tr>
                </table>
            </mat-card>
        </div>
        <div *ngIf="testResult != null" style="margin-top: 48px">
            <h2>Ergebnisse</h2>
            <div style="width: 100%">
                <mat-card
                    *ngFor="let torer of testResult?.testOrderResultExportRecords; let i = index"
                    style="margin-bottom: 10px"
                >
                    <h3 class="kiene-color"> Isolat: {{ torer.testOrderRecord?.isolatenNummer }} </h3>

                    <h4 style="color: #777">
                        Verdacht:
                        {{ getVerdachtString(torer.resultRecords[0].measuredValue) }}
                        | Kennzeichnung:
                        {{ torer.testOrderRecord?.kennzeichnung }} | Testart:
                        {{ testDescription.testOrderResultRecords[i]?.resultRecord?.testart }}
                        | Tierart:
                        {{ getTierartName(testDescription.testOrderResultRecords[i]?.testOrderRecord?.einsenderKuerzel) }}
                        | Kommentar:
                        {{ testDescription.testOrderResultRecords[i]?.testOrderRecord?.isoKommentar }}
                    </h4>
                    <table style="width: 100%; border-spacing: 0px" class="test-result-table">
                        <tr>
                            <th style="text-align: left; padding: 10px"> Antibiotika </th>
                            <th style="text-align: left; padding: 10px"> Ergebnis </th>
                            <th style="text-align: left; padding: 10px"> Messwert </th>
                        </tr>
                        <tr *ngFor="let rr of torer?.resultRecords; let j = index">
                            <td style="width: 20%; padding: 10px; border-bottom: 1px solid #ccc">
                                {{ rr?.antibiotikaName }}
                            </td>
                            <td style="width: 20%; padding: 10px; border-bottom: 1px solid #ccc">
                                {{ rr?.result }}
                            </td>
                            <td style="width: 20%; padding: 10px; border-bottom: 1px solid #ccc">
                                {{ rr?.measuredValue }}
                            </td>
                        </tr>
                    </table>
                </mat-card>
            </div>
        </div>
    </div>
</div>
